import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  compact?: boolean;
}

export default function ArticleCard({ article, compact = false }: ArticleCardProps) {
  return (
    <Link to={`/article/${article.id}`} className="group block cursor-pointer">
      <div className={`flex ${compact ? 'flex-row gap-3' : 'flex-col gap-3'}`}>
        <div
          className={`relative rounded-lg overflow-hidden bg-background-100 flex-shrink-0 ${
            compact ? 'w-24 h-24' : 'w-full aspect-[16/9]'
          }`}
        >
          <img
            src={article.cover}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-900">
              {article.category}
            </span>
            <span className="text-[11px] text-foreground-500">{article.date}</span>
          </div>
          <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
            {article.title}
          </h3>
          {!compact && (
            <p className="text-xs text-foreground-600 line-clamp-2 mb-2">{article.summary}</p>
          )}
          <div className="flex items-center gap-3 text-[11px] text-foreground-500">
            <span><i className="ri-eye-line mr-0.5"></i>{article.views} 阅读</span>
            <span><i className="ri-user-line mr-0.5"></i>{article.author}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}